import {
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faDownload,
  faEllipsisVertical,
  faLessThan,
  faPencil,
  faRightFromBracket,
  faShareFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import landscape from "../../../../../../../public/icons/expand-width.svg";
import portrait from "../../../../../../../public/icons/expand-height.svg";
import {
  dispatchEvent,
  handleClearCookie,
  scrollPage,
} from "../../../../../utis/helper";
import LanguageDropdown from "../../../../CommonComponents/LanguageDropdown/LanguageDropdown";
import { networkService } from "../../../../config/axios";
import Button from "../../../../Elements/Button";
import CustomTooltip from "../../../../Elements/Tooltip";
import SearchInput from "../pdfEditorElements/SearchInput";

const EditorHeader = ({
  pdfFile,
  setOpenSideSection,
  openSideSection,
  setZoomIndex,
  zoomIndex,
  pageNumber,
  setPageNumber,
  docFiles,
  setSelectedPdf,
  title,
  downloadStatus,
  selectedPdf,
  tlb,
  editorStatus,
  setLaserLINKEditStatus,
  showToolbar,
  showEditBtn,
  editortype,
  currentUserId,
  isPdfPublished,
  setIsPdfPublished,
  showThumbnail,
  otherLanguageAvailable
}) => {
  const [langName, setLangName] = useState({
    img: "",
    name: "",
    class: "flag-icon flag-icon-us",
    groupId: "",
  });
  const [showSearch, setShowSearch] = useState(false);
  const [userProfileData, setUserProfileData] = useState({});
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [backButtonLabel, setBackButtonLabel] = useState("Back");
  const pageNumberRef = useRef(null);
  const isFetchingRef = useRef(false);
  const initialLoadRef = useRef(false);

  // Track page-height baseline zoom for display calculation
  const [pageHeightBaseline, setPageHeightBaseline] = useState(null);

  const formatDownloadName = (name) => {
    const base = (name || "download").replace(/\.pdf$/i, "");
    const now = new Date();
    const yy = String(now.getFullYear()).slice(-2);
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    return `${base} ${yy}${mm}${dd}.pdf`;
  };

  const zoomingOptions = window.objInit?.zoomOptions;
  const arrayOfElements = Object.values(
    Object.entries(docFiles).length !== 0 && docFiles
  );
  const selectedLanguage = arrayOfElements?.find(
    (elem) => elem.id == pdfFile?.id
  );

  const getClosestZoomValueAndIndex = (currentScale, zoomingOptions, isZoomIn) => {
    const zoomValues = Object.values(zoomingOptions).map(opt => parseFloat(opt.value));
    const sortedZooms = zoomValues.filter(v => !isNaN(v)).sort((a, b) => a - b);

    const newValue = isZoomIn
      ? sortedZooms.find(v => v > currentScale) || 4
      : [...sortedZooms].reverse().find(v => v < currentScale) || 0.25;

    const newIndex = Object.keys(zoomingOptions).findIndex(
      key => parseFloat(zoomingOptions[key].value) === newValue
    );

    return { newValue, newIndex };
  };

  const onScroll = () => {
    const input = document.getElementById("pageNumber");
    setCurrentPageNumber(parseInt(input?.value));
  };

  const handleResetZoom = () => {
    setZoomIndex({
      ...zoomIndex,
      index: 'page-height',
      value: '1',
      oldValue: zoomIndex.value,
    });
    // Scroll to current page after zoom reset to keep page in view
    setTimeout(() => {
      const input = document.getElementById("pageNumber");
      if (input && input.value) {
        scrollPage(input.value, "smooth");
      }
    }, 100);
  };

  const handleZoom = (option) => {
    if (option === "in" && (zoomIndex.index < 8 || zoomIndex.index == 'page-height' || zoomIndex?.index == 'page-width')) {
      let newValue, newIndex;
      if (zoomIndex.index === 'page-height' || zoomIndex.index === 'page-width') {
        ({ newValue, newIndex } = getClosestZoomValueAndIndex(zoomIndex.value, zoomingOptions, true));
      } else {
        newIndex = zoomIndex.index + 1;
        newValue = zoomingOptions[Object.keys(zoomingOptions)[newIndex]].value;
      }
      setZoomIndex({
        ...zoomIndex,
        index: newIndex,
        value: newValue,
        oldValue: zoomIndex.value,
      });
    } else if (option === "out" && ((zoomIndex.index > 0 && zoomIndex.index < 9) || zoomIndex.index == 'page-height' || zoomIndex?.index == 'page-width')) {
      let newValue, newIndex;
      if (zoomIndex.index === 'page-height' || zoomIndex.index === 'page-width') {
        ({ newValue, newIndex } = getClosestZoomValueAndIndex(zoomIndex.value, zoomingOptions, false));
      } else {
        newIndex = zoomIndex.index - 1;
        newValue = zoomingOptions[Object.keys(zoomingOptions)[newIndex]].value;
      }
      setZoomIndex({
        ...zoomIndex,
        index: newIndex,
        value: newValue,
        oldValue: zoomIndex.value,
      });
    } else if (option == "landscape") {
      setZoomIndex({
        ...zoomIndex,
        index: 'page-width',
        value: "2",
        oldValue: zoomIndex.value,
      });
      // Scroll to current page after landscape zoom to keep page in view
      setTimeout(() => {
        const input = document.getElementById("pageNumber");
        if (input && input.value) {
          scrollPage(input.value, "smooth");
        }
      }, 100);
    } else if (option == "portrait") {
      setZoomIndex({
        ...zoomIndex,
        index: 'page-height',
        value: "1",
        oldValue: zoomIndex.value,
      });
      // Scroll to current page after portrait zoom to keep page in view
      setTimeout(() => {
        const input = document.getElementById("pageNumber");
        if (input && input.value) {
          scrollPage(input.value, "smooth");
        }
      }, 100);
    }
  };

  const handleSelect = (value) => {
    setLangName({
      img: value?.language?.locale,
      class: value?.language?.class,
      name: value?.language?.name,
      groupId: value?.language?.group_id,
    });
    setSelectedPdf(value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const num = parseInt(e.target.value, 10);
      dispatchEvent("change", "pageNumber");
      setPageNumber(num);
      scrollPage(num, "instant");
      e.preventDefault();
    }
  };

  const updateInputRefEvent = (valueToUpdate) => {
    if (pageNumberRef && pageNumberRef.current != null) {
      setTimeout(() => {
        if (pageNumberRef.current) pageNumberRef.current.value = valueToUpdate || 1;
      }, 400);
    }
  };

  // Calculate user-friendly display zoom relative to page-height baseline
  const calculateDisplayZoom = () => {
    // When in page-height or page-width mode, always show 100%
    if (zoomIndex.index === 'page-height' || zoomIndex.index === 'page-width') {
      return 100;
    }

    // If baseline hasn't been established yet, show actual zoom
    if (!pageHeightBaseline || pageHeightBaseline === 0) {
      return Math.floor(parseFloat(zoomIndex.value) * 100);
    }

    // Calculate zoom relative to page-height baseline
    // Example: if baseline is 2.25 (225%) and current is 3.0, show (3.0/2.25)*100 = 133%
    const currentZoom = parseFloat(zoomIndex.value);
    const relativeZoom = (currentZoom / pageHeightBaseline) * 100;
    return Math.floor(relativeZoom);
  };

  const goBackToListing = () => {
    // If on preview page, handle navigation
    if (editortype == "preview") {
      // Check if there's history to go back to (not a new tab)
      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      // If opened in new tab, check URL parameter for source page
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const fromPage = urlParams.get('from');

        if (fromPage === 'KDFs') {
          window.location.href = '/kdfs';
          return;
        } else if (fromPage === 'Settings') {
          // Need to know which KDF's settings, so go to kdfs as fallback
          window.location.href = '/kdfs';
          return;
        }
      } catch (error) {
        console.warn('Failed to read from parameter:', error);
      }

      // Fallback to KDFs listing if no valid from parameter
      window.location.href = '/kdfs';
      return;
    }

    if (window.opener && !window.opener.closed) {
      // Trigger refresh on the parent window before closing
      // Check which page we came from and call the appropriate refresh function
      try {
        const storedState = sessionStorage.getItem('editorNavigationState');
        if (storedState) {
          const { sourcePage } = JSON.parse(storedState);

          if (sourcePage === 'Settings' && typeof window.opener.refreshKDFSettings === 'function') {
            window.opener.refreshKDFSettings();
          } else if (sourcePage === 'KDFs' && typeof window.opener.refreshKDFList === 'function') {
            window.opener.refreshKDFList();
          }
        } else {
          // Fallback: if no source page stored, assume KDFs listing
          if (typeof window.opener.refreshKDFList === 'function') {
            window.opener.refreshKDFList();
          }
        }
      } catch (error) {
        console.warn('Failed to refresh parent window:', error);
      }

      window.opener.focus(); // Switch focus to the listing tab
      window.close(); // Close the editor tab
    } else {
      window.location.href = "/kdfs"; // Fallback if opener is not available
    }
  };

  useEffect(() => {
    updateInputRefEvent(pageNumber);
  }, [pageNumber]);

  // Track page-height baseline when it's calculated by PdfViewer
  useEffect(() => {
    if ((zoomIndex.index === 'page-height' || zoomIndex.index === 'page-width') && zoomIndex.value) {
      const numericValue = parseFloat(zoomIndex.value);
      // Only update baseline if it's a valid number and has changed
      if (numericValue > 0 && numericValue !== pageHeightBaseline) {
        setPageHeightBaseline(numericValue);
      }
    }
  }, [zoomIndex.value, zoomIndex.index]);

  useEffect(() => {
    setLangName({
      ...langName,
      groupId: docFiles[0]?.group_id,
    });
  }, [docFiles]);

  useEffect(() => {
    setIsPdfPublished(
      window.objInit &&
      window.objInit.live_files_count &&
      window.objInit.live_files_count[
      selectedPdf?.language?.locale ?? pdfFile?.language
      ] > 0
    );
  }, [selectedPdf]);

  useEffect(() => {
    // Prevent duplicate calls in React StrictMode
    if (initialLoadRef.current) {
      return;
    }
    
    initialLoadRef.current = true;
    
    const fetchUserData = async () => {
      // Prevent duplicate calls
      if (isFetchingRef.current || !currentUserId) {
        return;
      }
      
      isFetchingRef.current = true;
      try {
        const response = await networkService(
          `profiles/${currentUserId}.json`,
          "GET"
        );
        setUserProfileData(response?.data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        isFetchingRef.current = false;
      }
    };
    
    if (!editorStatus) {
      setOpenSideSection(tlb?.show_thumbnail ?? true);
    }
    if (currentUserId) {
      fetchUserData();
    }

    // Set Back button label based on source page from URL parameter
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const fromPage = urlParams.get('from');

      if (fromPage) {
        setBackButtonLabel(fromPage);
      } else {
        // Fallback to sessionStorage
        const storedState = sessionStorage.getItem('editorNavigationState');
        if (storedState) {
          const { sourcePage } = JSON.parse(storedState);
          if (sourcePage) {
            setBackButtonLabel(sourcePage);
          }
        } else if (editortype === "preview") {
          // If on preview page, back button should say "Editor"
          setBackButtonLabel("Editor");
        }
      }
    } catch (error) {
      // If parsing fails, use default "Back"
      console.warn('Failed to read navigation state for back button:', error);
    }

    document.getElementById("pageNumber").addEventListener("change", onScroll);
  }, []);

  return (
    <header
      className="header-editor"
      style={{ display: showToolbar === false ? "none" : "" }}
    >
      <div className={selectedPdf?.num_pages > 1 ? "h-first" : ""}>
        <div className="d-flex align-items-center">
          {editorStatus && (
            <div>
              <button
                className="back-button"
                onClick={goBackToListing}
              >
                {/* <FontAwesomeIcon className="me-2" icon={faLessThan} /> */}
                <img src="/icons/arrow_backword_ios.svg" />
               <span> {backButtonLabel}</span>
              </button>
            </div>
          )}
          <>
            {showThumbnail && (
              <CustomTooltip
                title={<p className="p-1 text-light">Toggle Sidebar</p>}
                placement={"bottom"}
              >
                <div
                  className="ms-2 three-dots"
                  onClick={() => setOpenSideSection(!openSideSection)}
                >
                  <FontAwesomeIcon icon={faEllipsisVertical} className="fs-4" />
                </div>
              </CustomTooltip>
            )}
            <div
              className={`${selectedPdf?.num_pages > 1
                ? "d-flex align-items-center  editor-inp"
                : "d-none"
                } ${tlb?.cyoa_enabled == true ? "d-none" : ""}`}
            >
              <input
                type="number"
                ref={pageNumberRef}
                className="edit-value-inp ms-1 me-1"
                id="pageNumber"
                min={1}
                max={selectedPdf?.num_pages}
                onKeyDown={handleKeyDown}
              />
              <p className="text-light">/ {selectedPdf?.num_pages}</p>
            </div>

            {tlb?.cyoa_enabled != true && (
          <div className="h-first-search align-items-center">
            <SearchInput showSearch={showSearch} setShowSearch={setShowSearch} />
          </div>
        )}
          </>
        </div>
      </div>
      <div className="title edit-middle-h d-flex align-items-center justify-content-between px-2">
        {/* {tlb?.cyoa_enabled != true && (
          <div className="h-first-search align-items-center">
            <SearchInput showSearch={showSearch} setShowSearch={setShowSearch} />
          </div>
        )} */}
        <p className="text-light editor-header-text">
          {title?.substring(0, 40)} {title.length > 40 ? "..." : ""}
        </p>
        <div className="d-flex align-items-center gap-2">
          {/* {showEditBtn && (
            <Button
              text={
                <>
                  Edit KDF
                  <FontAwesomeIcon icon={faPencil} className="success ms-1" />
                </>
              }
              classList={"success"}
              addonClass={"mx-2"}
              onClick={() => (window.location = `/editor/${pdfFile?.doc_id}#page=${currentPageNumber}`)}
            />
          )} */}
          {/* {editorStatus && isPdfPublished && (
            <button>
              <CustomTooltip
                title={<p className="p-1 text-light">Share</p>}
                placement={"bottom"}
              >
            
                <img src="/icons/ios_share.svg" onClick={() => setLaserLINKEditStatus(true)} />

              </CustomTooltip>
            </button>
          )} */}
        </div>
      </div>
      <div className="edior-last-el">
          {editorStatus && isPdfPublished && (
            <button onClick={() => setLaserLINKEditStatus(true)}  className="share-kdf">
              <CustomTooltip
                title={<p className="p-1 text-light">Share</p>}
                placement={"bottom"}
              >
                <>
            
                <img src="/icons/ios_share.svg" /> Share
                </>

              </CustomTooltip>
            </button>
          )}
        <div className="icons-editor">
        {tlb?.cyoa_enabled != true && ( 
        <>
          <span className="d-flex align-items-center gap-2">
          <CustomTooltip
            title={<p className="p-1 text-light">Zoom Out</p>}
            placement={"bottom"}
          >
            {/* <FontAwesomeIcon
              icon={faCircleMinus}
              onClick={() => handleZoom("out")}
              className="fs-4 me-2 cursor-pointer"
              id="zoomOut"
            /> */}
          <img src="/icons/remove.svg" onClick={() => handleZoom("out")} />
          </CustomTooltip>

          {/* Original zoom display - kept for internal calculations, hidden from view */}
          <div className={"fs-6 text-light"} style={{ display: 'none' }}>
            {Math.floor(zoomIndex.value*100)}%
          </div>

          {/* NEW: User-friendly display layer showing zoom relative to page-height baseline */}
          <div className={"fs-6 text-light"}>
            {calculateDisplayZoom()}%
          </div>

          <CustomTooltip
            title={<p className="p-1 text-light ">Zoom In</p>}
            placement={"bottom"}
          >
            {/* <FontAwesomeIcon
              icon={faCirclePlus}
              className="fs-4 me-2 cursor-pointer"
              onClick={() => handleZoom("in")}
              id="zoomIn"
            /> */}
            <img src="/icons/add.svg" onClick={() => handleZoom("in")} />
          </CustomTooltip>

          {/* Reset to 100% (page-height) button - only show when not at 100% */}
          {calculateDisplayZoom() !== 100 && (
            <CustomTooltip
              title={<p className="p-1 text-light">Reset to 100%</p>}
              placement={"bottom"}
            >
              <button
                onClick={handleResetZoom}
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: '4px',
                  color: '#fff',
                  fontSize: '11px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  padding: '4px 10px',
                  height: '34px',
                  marginLeft: '4px',
                  marginRight: '4px',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.25)';
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.15)';
                  e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                }}
              >
                Reset
              </button>
            </CustomTooltip>
          )}
          </span>
          {/* Show portrait/landscape icons only when at 100% (when Reset is hidden) */}
          {calculateDisplayZoom() === 100 && (
            <span className="d-flex align-items-center gap-2">
            <CustomTooltip
              title={<p className="p-1 text-light">Full height</p>}
              placement={"bottom"}
            >
              <img
                src={portrait}
                alt="portrait"
                height="35px"
                width="30px"
                onClick={() => handleZoom("portrait")}
                className="me-2 cursor-pointer"
              />
            </CustomTooltip>
            <CustomTooltip
              title={<p className="p-1 text-light">Full width</p>}
              placement={"bottom"}
            >
              <img
                src={landscape}
                alt="landscape"
                height="30px"
                width="35px"
                onClick={() => handleZoom("landscape")}
                className="me-2 cursor-pointer"
              />
            </CustomTooltip>
            </span>
          )}
        </>
        )}
          <NavDropdown
            title={
              // <FontAwesomeIcon
              //   className="fs-4 cursor-pointer"
              //   icon={faCircleInfo}
              // />
              <img src="/icons/info-icon.svg"/>
            }
            id="navbarScrollingDropdown"
            className="px-0 header-info-icons"
          >
            <NavDropdown.Item className="profile-drop">
              <div className="text-dark">
                KDF:{" "}
                <span
                  onClick={() =>
                    (window.location = `/kdfs/token/${langName?.groupId}`)
                  }
                >
                  {title}
                </span>
              </div>
            </NavDropdown.Item>
            <NavDropdown.Item
              className="profile-drop"
              download={formatDownloadName(selectedLanguage?.title ?? title)}
              href={selectedPdf?.file?.url ?? selectedPdf?.url}
              id="download-pdf"
            >
              <div className="text-dark">
                PDF source:
                <span className="ms-1">{selectedLanguage?.title}</span>
              </div>
            </NavDropdown.Item>
          </NavDropdown>
        </div>
        <div className=" icons-editor header-flag-dd">
          {
            otherLanguageAvailable &&
            <LanguageDropdown
              arrayOfElements={arrayOfElements}
              name={langName}
              handleSelect={handleSelect}
              selectedLanguage={selectedLanguage?.language}
            />
          }
          {downloadStatus && (
            <a
              href={selectedPdf?.file?.url ?? selectedPdf?.url}
              download={formatDownloadName(docFiles?.title ?? title)}
              id="download-pdf"
            >
              <FontAwesomeIcon icon={faDownload} className="ms-2" />
            </a>
          )}
        </div>
        {editorStatus && (
          <NavDropdown
            title={
              <>
                <img
                  className="user-imgs rounded-circle"
                  src={`https:${userProfileData?.image}`}
                  alt=""
                />
                <span className="mx-2 user-name-header"></span>
              </>
            }
            id="navbarScrollingDropdown"
            className="header-info-iconss"
          >
            <NavDropdown.Item className="profile-drop" href="/customizations">
              {/* <FontAwesomeIcon icon={faCircleInfo} className="" />{" "} */}
              <img src="/icons/settings_applications.svg"/>
              Customizations
            </NavDropdown.Item>
            <NavDropdown.Item
              className="profile-drop"
              onClick={handleClearCookie}
            >
              {/* <FontAwesomeIcon
                icon={faRightFromBracket}
                className="active-icon"
              /> */}
              <img src="/icons/logout.svg"/>
              Logout
            </NavDropdown.Item>
          </NavDropdown>
        )}
      </div>
    </header>
  );
};

export default EditorHeader;
